import { render, staticRenderFns } from "./TeamRoles.vue?vue&type=template&id=8795fe96&scoped=true&"
import script from "./TeamRoles.vue?vue&type=script&lang=js&"
export * from "./TeamRoles.vue?vue&type=script&lang=js&"
import style0 from "./TeamRoles.vue?vue&type=style&index=0&id=8795fe96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8795fe96",
  null
  
)

export default component.exports